<button type="button" class="ui-toolbar-btn" [class.is-active]="active" [class.is-open]="open"
  [disabled]="disabled" [attr.aria-label]="ariaLabel || null"
  [attr.aria-expanded]="ariaExpanded === null ? null : ariaExpanded" (click)="onClick($event)">
  <ng-content></ng-content>
</button>
